import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "withdraw-password-page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = ["value", "onInput", "onKeydown"]
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = ["value", "onInput", "onKeydown"]
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "btn_container" }

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

import CustomHeader from '../components/common/customHeader.vue'
import MainButton from '../../themeThree/components/common/mainButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawPWPage',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()

const newPassword = ref(['','','','','',''])
const confirmPassword = ref(['','','','','',''])

const newInputs = ref<HTMLInputElement[]>([])
const confirmInputs = ref<HTMLInputElement[]>([])

const handleNewInput = (e:any,index:number)=>{
  const value = e.target.value
  if(!/^[0-9]?$/.test(value)){
    e.target.value=''
    return
  }

  newPassword.value[index]=value

  if(value && index < 5){
    newInputs.value[index+1].focus()
  }
}

const handleConfirmInput = (e:any,index:number)=>{
  const value = e.target.value
  if(!/^[0-9]?$/.test(value)){
    e.target.value=''
    return
  }

  confirmPassword.value[index]=value

  if(value && index < 5){
    confirmInputs.value[index+1].focus()
  }
}

const handleNewBackspace = (e:any,index:number)=>{
  if(e.key==='Backspace' && !newPassword.value[index] && index>0){
    newInputs.value[index-1].focus()
  }
}

const handleConfirmBackspace = (e:any,index:number)=>{
  if(e.key==='Backspace' && !confirmPassword.value[index] && index>0){
    confirmInputs.value[index-1].focus()
  }
}

const isFillField = computed(()=>{
  return newPassword.value.every(v=>v!=='') &&
         confirmPassword.value.every(v=>v!=='')
})

const confirmWithdraw = ()=>{
  const pass1 = newPassword.value.join('')
  const pass2 = confirmPassword.value.join('')

  if(pass1 !== pass2){
    alert('Password not match')
    return
  }

}

const backNavigate = () => {
  userStore.setRechargeBonusType(0)
  userStore.setTakeFirstDeposit(false)
  router.go(-1)
}

const goToFund = () => {
  router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('withdrawPassword.title'),
      "is-popup-close-back-icon": true,
      onClosePopup: backNavigate,
      "show-fund": false,
      onGoToFund: goToFund
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('withdrawPassword.configTitle')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('withdrawPassword.newPassword')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newPassword.value, (item, index) => {
          return (_openBlock(), _createElementBlock("input", {
            key: 'new'+index,
            ref_for: true,
            ref_key: "newInputs",
            ref: newInputs,
            maxlength: "1",
            type: "password",
            class: "box",
            value: item,
            onInput: ($event: any) => (handleNewInput($event,index)),
            onKeydown: ($event: any) => (handleNewBackspace($event,index))
          }, null, 40, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('withdrawPassword.confirmPassword')), 1),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmPassword.value, (item, index) => {
          return (_openBlock(), _createElementBlock("input", {
            key: 'confirm'+index,
            ref_for: true,
            ref_key: "confirmInputs",
            ref: confirmInputs,
            maxlength: "1",
            type: "password",
            class: "box",
            value: item,
            onInput: ($event: any) => (handleConfirmInput($event,index)),
            onKeydown: ($event: any) => (handleConfirmBackspace($event,index))
          }, null, 40, _hoisted_9))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('withdrawPassword.firstWithdrawTip')), 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(MainButton, {
          title: _ctx.$t('withdrawPassword.withdrawNow'),
          activeStatus: isFillField.value,
          onClick: confirmWithdraw,
          radius: '10'
        }, null, 8, ["title", "activeStatus"])
      ])
    ])
  ]))
}
}

})